'use client';

import AboutHero from './AboutHero';
import AboutStory from './AboutStory';
import AboutValues from './AboutValues';

export default function AboutPage() {
  return (
    <div className="min-h-screen w-full bg-[#FBF7F0] py-8 md:py-12 lg:py-14">
      <div className="mx-auto max-w-[1200px] space-y-8 px-4 md:px-6 lg:space-y-10 lg:px-8">
        <AboutHero />
        <AboutStory />
        <AboutValues />
      </div>
    </div>
  );
}
